import { GroupsContainer } from './views/groups/GroupsContainer'
export default GroupsContainer
